import { apiSlice } from "./apiSlice";
// export const Activesizelist = createAsyncThunk('/activesizelist', async () => {
//   const response = await ApiHelperFunction({
//     urlPath: 'size/active/size',
//     method: 'GET',
//   });
//   return response;
// });
export const FaqSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        faqlist: builder.query({
            query: (data) => ({
                url: 'faq',
                method: 'GET',
                credentials: "include",
            }),
            providesTags: ['faq']

        }),
        Create_Update_faq: builder.mutation({
            query: (data) => ({
                url: 'faq',
                method: 'POST',
                body: data,
                credentials: "include",
            }),
            invalidatesTags: ['faq']

        }),
        delete_faq: builder.mutation({
            query: (data) => ({
                url: 'faq',
                method: 'DELETE',
                body: data,
                credentials: "include",
            }),
            invalidatesTags: ['faq']

        }),

    }),
});

export const {
    useCreate_Update_faqMutation,
    useFaqlistQuery,
    useDelete_faqMutation

} = FaqSlice;

